import OverflowMenu from "./OverflowMenu";

(() => {
    const overflowMenuContainer = document.querySelector(
        ".overflow-menu__list"
    );
    const overflowItem = document.querySelector(".overflow-menu-more");
    const overflowItemButton = document.querySelector(
        ".overflow-menu-more__button"
    );
    const overflowItemContainer = document.querySelector(
        ".overflow-menu-more__menu"
    );

    if (
        overflowMenuContainer &&
        overflowItem &&
        overflowItemButton &&
        overflowItemContainer
    ) {
        const overflowMenu = new OverflowMenu(
            overflowMenuContainer,
            ".overflow-menu__item",
            overflowItem,
            overflowItemButton,
            overflowItemContainer
        );

        overflowMenu.init();
    }
})();
